var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left pb-2"},[_c('v-btn',{staticClass:"ml-0 mr-2",attrs:{"color":"warning"},on:{"click":function($event){return _vm.$emit('validate')}}},[_vm._v(" validate ")]),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.isValid},on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v(" Save & Continue ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }